// Copyright (c) 2018 Deere & Company

import {buildDate} from './build-date';
import {translate} from './translation-service';

export const getUseAmount = measurement =>
    `${measurement.useAmount.amount} ${measurement.useAmount.unit.value}`;

export const getUseAmountUpdated = measurement =>
    `(${translate('UPDATED')} ${buildDate(measurement.date)})`;



// WEBPACK FOOTER //
// ./src/shared/services/get-use-amount.js